import Vue from "vue";
export default {
    SET_TITLE: (state, text) => {
        Vue.set(state, "page_title", text );
    }
}